import ResponsiveImage from "./modules/responsive-image";
import Link from "next/link";

export default function TeasePost({
  title,
  excerpt,
  date,
  image,
  url,
  link_text,
  is_large = false,
  color = "",
}) {
  return (
    <div
      className={`tease-post ${is_large ? "tease-post--is-large" : ""} ${
        color === "green" ? "tease-post--is-green" : ""
      }`}
    >
      <Link href={url}>
        <div>
          {image && (
            <figure className="tease-post__image mb-20">
              <ResponsiveImage
                image={image}
                classes="tease-post__image__img"
                layout="fill"
              />
            </figure>
          )}
          <div className="tease-post__meta">
            {title && (
              <h3
                className="tease-post__title"
                dangerouslySetInnerHTML={{ __html: title }}
              />
            )}
            {date && (
              <p className="tease-post__date pb-10">
                <i className="fas fa-clock mr-5" /> {date}
              </p>
            )}
            {excerpt && (
              <div
                className="tease-post__excerpt pb-20"
                dangerouslySetInnerHTML={{ __html: excerpt }}
              />
            )}
            <p className="tease-post__link">{link_text}</p>
          </div>
        </div>
      </Link>
    </div>
  );
}
